import React from 'react';
import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import type SearchConstituent from '@/types/api/SearchConstituent';
import ConstituentLastInteraction from '../components/ConstituentLastInteraction';
import ColumnMaxMinWidthClasses from '../constants/ColumnMaxMinWidthClasses';

const lastInteractionDateColumn = {
  columnKey: ConstituentSearchColumn.LAST_INTERACTION_DATE,
  headerName: 'LAST_INTERACTION',
  TableCellProps: {
    className: ColumnMaxMinWidthClasses,
  },
  render: (constituent: SearchConstituent) => (
    <ConstituentLastInteraction constituent={constituent} />
  ),
};

export default lastInteractionDateColumn;
